import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Alert } from '../../components/ui/Alert';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) throw error;
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="w-12 h-12 bg-meetoi-navy rounded-xl flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiIcons.FiLayers} className="text-white text-2xl" />
        </div>
        <h2 className="text-center text-3xl font-extrabold text-meetoi-navy">Reset your password</h2>
        <p className="mt-2 text-center text-sm text-slate-600">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-xl sm:px-10 border border-slate-100">
          {success ? (
            <div className="text-center">
              <Alert 
                variant="success" 
                title="Email sent" 
                message="Check your email for a link to reset your password. If it doesn't appear within a few minutes, check your spam folder."
                className="mb-6"
              />
              <Link to="/login">
                <Button variant="secondary" className="w-full">Return to sign in</Button>
              </Link>
            </div>
          ) : (
            <>
              {error && <Alert variant="error" message={error} className="mb-6" />}
              
              <form className="space-y-6" onSubmit={handleSubmit}>
                <Input
                  label="Email address"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <Button type="submit" className="w-full" isLoading={loading}>
                  Send reset link
                </Button>

                <div className="text-center mt-4 text-sm">
                  <Link to="/login" className="font-medium text-slate-600 hover:text-meetoi-navy">
                    Back to sign in
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};